// extracted by mini-css-extract-plugin
export default {"row":"QuC1MEy69p0zqpq6KR_t","title":"nrOHvXzTpPRN6CjqST_o","content":"UUDOwz4MwLlluIajfQhN"};